import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=0395440d&scoped=true&"
import script from "./Section4.vue?vue&type=script&lang=js&"
export * from "./Section4.vue?vue&type=script&lang=js&"
import style0 from "./Section4.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section4.vue?vue&type=style&index=1&id=0395440d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395440d",
  null
  
)

export default component.exports